export const SKY_ACCOUNT_CREATED = "sky_account_created";
export const SKY_LAST_TRANSCRIBED_TEXT = "sky_last_transcribed_text";
export const ACCEPTED_FILE_TYPES = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
};

export const AMPLITUDE_API_KEY = "651d126461839884d4455430b6a02104";
export const AMPLITUDE_SERVER_URL = `${import.meta.env.VITE_BASE_API_URL}/organizations/behavior`;

export const CALENDLY_URL = "https://calendly.com/farrell-usesky/request-demo";
export const DEMO_CASE_NAME = "Case #1 Voice Recording";

export const DEMO_CASE_STEPS = [
  { title: "Creating Case", description: "Please wait a moment" },
  { title: "Preparing File", description: "Please wait a moment" },
  { title: "Uploading File", description: "Please wait a moment" },
];
